import { render, staticRenderFns } from "./SplitPayments.vue?vue&type=template&id=12093d02&scoped=true"
import script from "./SplitPayments.vue?vue&type=script&lang=js"
export * from "./SplitPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12093d02",
  null
  
)

export default component.exports